// removed by extract-text-webpack-plugin
module.exports = {"text":"textbox-element-options__text___2gsZl"};


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/textbox-element-options.css
// module id = 790
// module chunks = 0